/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/

define([], function(){
	class WidgetTitleTruncateAPI{
		/**
		* @function WidgetTitleTruncateAPI#getExtensionHooks
		* @param None
		* @returns {Object}
		*/
		getExtensionHooks() { }

		/**
		* @function WidgetTitleTruncateAPI#setUpdateModelContent
		* @param function
		* @returns {}
		*/
		setUpdateModelContent() {}

		/**
		* @function WidgetTitleTruncateAPI#getState
		* @param None
		* @returns {Object}
		*/
		getState() { }


		/**
		* @function WidgetTitleTruncateAPI#setTitleHighlighter
		* @param function
		* @returns
		*/
		setTitleHighlighter() { }

		/**
		* @function WidgetTitleTruncateAPI#highlightTitle
		* @param None
		* @returns
		*/
		highlightTitle() { }
	}

	return WidgetTitleTruncateAPI;
});
